import { SVGProps } from 'react';

const SvgCake = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M13 11h4a4 4 0 013.98 3.605l-.687.688C19.133 16.453 18.039 17 17 17c-.478 0-.812-.148-1.435-.598l-.29-.21C14.137 15.361 13.306 15 12 15c-1.282 0-2.121.337-3.42 1.153l-.299.188C7.5 16.828 7.065 17 6.5 17c-.673 0-1.319-.283-1.915-.773a4.214 4.214 0 01-.76-.792c-.24-.303-.327-.413-.787-.988A4 4 0 017 11h4V9h2v2z'
					fill='currentColor'
				/>
				<path
					d='M12 7a2 2 0 002-2c0-.736-.667-1.736-2-3-1.333 1.264-2 2.264-2 3a2 2 0 002 2zM21 17.357V21a1 1 0 01-1 1H4a1 1 0 01-1-1v-3.502c.098.09.204.182.316.275C4.24 18.533 5.307 19 6.5 19c1.026 0 1.766-.294 2.838-.961l.306-.192C10.65 17.214 11.184 17 12 17c.799 0 1.27.206 2.1.809l.294.215c.933.673 1.616.976 2.606.976 1.375 0 2.71-.56 4-1.643z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgCake;
